module.exports = __webpack_public_path__ + "img/grey.fda01563.png";